// Base path for frontend assets and backend endpoints.
// On the server, both React build and PHP files live under /esipro/.
// Locally (Laragon), PHP is at the domain root while React is at /esipro/.
const BASE = process.env.PUBLIC_URL || "";

// Set to true when PHP files are in the same directory as the React build (server).
// Set to false when PHP files are at the domain root (local Laragon setup).
const PHP_SAME_BASE = process.env.REACT_APP_PHP_SAME_BASE === "true";

/**
 * Build URLs for frontend assets and backend endpoints.
 *
 * Local:  api("/getProjects.php") → "/getProjects.php"
 *         api("/Progetti/1/img.jpg") → "/esipro/Progetti/1/img.jpg"
 *
 * Server: api("/getProjects.php") → "/esipro/getProjects.php"
 *         api("/Progetti/1/img.jpg") → "/esipro/Progetti/1/img.jpg"
 */
export function api(path) {
    if (/\.php($|\?)/i.test(path) && !PHP_SAME_BASE) {
        return path;
    }

    return `${BASE}${path}`;
}

export default BASE;
